export default "__VITE_ASSET__DjmlAi9L__"